import { mediabankApi as api, mediabankHeaders } from '../../mediabank';

const getValues = async urlParams =>
    await api.get(`/tags/happenings/autocomplete`, {
        urlParams,
        headers: mediabankHeaders(),
    });

export default { getValues };
